export default "__VITE_ASSET__0295596d__"